module.exports = __webpack_public_path__ + "static/media/32-2.e2fcede4.mp3";